import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyTenancyOption({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-6.9%"
          y="-6.1%"
          width="113.9%"
          height="117.1%"
          filterUnits="objectBoundingBox"
          id="pic-empty-tenancy-option_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M0 4.9v75.23c0 .74.25 1.44.68 1.96.44.52 1.04.81 1.66.81h96.12c1.3 0 2.34-1.24 2.34-2.77V4.9a4 4 0 00-4-4H4a4 4 0 00-4 4z"
          id="pic-empty-tenancy-option_svg__b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M174.9 147.5c-43.2 2.41-60.36 17.5-100.9 15.93-47.85-1.86-78.23-20.72-69.66-62.12C12.37 62.58 70 37 108 19c119.31-56.52 185.35 121.9 66.9 128.5z"
          fill="#E9EDFB"
        />
        <path
          d="M174.9 147.5c-38.25 1.52-55.1 16.03-98.21 16.03-26.57 0-85.29-8.93-71.83-63.98C47.43 142 239.12 59.1 237.26 93.7c-1.94 36.14-31.43 52.57-62.36 53.8z"
          stroke="#979797"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(70 45)">
          <use
            fill="#000"
            filter="url(#pic-empty-tenancy-option_svg__a)"
            xlinkHref="#pic-empty-tenancy-option_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-tenancy-option_svg__b" />
        </g>
        <g transform="translate(79 67.6)">
          <rect fill="#8F9DD6" width={21.6} height={12.6} rx={1.31} />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            transform="rotate(-180 72 6.3)"
            x={61.2}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#8F9DD6"
            transform="rotate(-180 41.4 6.3)"
            x={30.6}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            y={19.8}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            transform="rotate(-180 72 26.1)"
            x={61.2}
            y={19.8}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            transform="rotate(-180 41.4 26.1)"
            x={30.6}
            y={19.8}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            y={39.6}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
          <rect
            fill="#444053"
            fillRule="nonzero"
            opacity={0.1}
            transform="rotate(-180 41.4 45.9)"
            x={30.6}
            y={39.6}
            width={21.6}
            height={12.6}
            rx={1.31}
          />
        </g>
        <path fill="#FFF" d="M83.5 46h70.2v9H83.5z" />
        <path
          d="M70 48.18V59.5h100.8V48.18a2.1 2.1 0 00-.68-1.54 2.43 2.43 0 00-1.66-.64H72.34c-.62 0-1.22.23-1.66.64-.43.4-.68.96-.68 1.54zm25.2 5.92a1.8 1.8 0 110-3.6 1.8 1.8 0 010 3.6zm50.4 0a1.8 1.8 0 111.27-.53c-.34.34-.8.53-1.27.53z"
          fill="#666"
        />
        <g transform="translate(138 86)">
          <circle
            stroke="#8F9DD6"
            strokeWidth={4.59}
            fill="#FAFAFA"
            fillRule="nonzero"
            cx={28}
            cy={28}
            r={25.71}
          />
          <path fill="#666" d="M29 26.5h16v3H29zm-12.62-6.11l10.63 5.56-1.4 2.66L15 23.05z" />
          <circle fill="#666" cx={28} cy={28} r={4} />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyTenancyOption.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyTenancyOption.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyTenancyOption svgRef={ref} {...props} />
));
export default ForwardRef;
